import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-trip-actions-dropdown',
  templateUrl: './trip-actions-dropdown.component.html',
  styleUrls: ['./trip-actions-dropdown.component.css']
})
export class TripActionsDropdownComponent implements OnInit, OnChanges {
  environment = environment;
  @Input() assign;
  @Input() preCooperates;
  @Input() status;
  @Input() isView;
  @Input() isSmsAllowed;
  @Input() isAutoFarmoutDispatch;
  @Input() isFarmoutIntegration;
  @Input() allowPostAdjustment;
  @Input() isConfirmationCalls;
  @Input() timeZone;

  @Output() recalculateFare = new EventEmitter<any>();
  @Output() calculateFare = new EventEmitter<any>();
  @Output() markReady = new EventEmitter<any>();
  @Output() markVip = new EventEmitter<any>();
  @Output() notAnswer = new EventEmitter<any>();
  @Output() badPhoneNumber = new EventEmitter<any>();

  @Output() markConfirmed = new EventEmitter<any>();
  @Output() markVoicemail = new EventEmitter<any>();
  @Output() markMultiload = new EventEmitter<any>();
  @Output() clone = new EventEmitter<any>();
  @Output() clone2 = new EventEmitter<any>();
  @Output() sendForAuth = new EventEmitter<any>();
  @Output() remove = new EventEmitter<any>();
  @Output() markNoShow = new EventEmitter<any>();

  @Output() verifiedCancelled = new EventEmitter<any>();
  @Output() finishedCancelled = new EventEmitter<any>();
  // @Output() addAdditionalNote = new EventEmitter<any>();
  @Output() addBillerNote = new EventEmitter<any>();
  @Output() tripNotes = new EventEmitter<any>();
  @Output() cancelInprogress = new EventEmitter<any>();
  @Output() markCompleted = new EventEmitter<any>();
  @Output() reroute = new EventEmitter<any>();
  @Output() markDvRequired = new EventEmitter<any>();
  @Output() isPaid = new EventEmitter<any>();
  @Output() addSpecialRates = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() assignTripAction = new EventEmitter<any>();
  @Output() tripFullDetail = new EventEmitter<any>();
  @Output() tripDetail = new EventEmitter<any>();
  @Output() farmoutDetail = new EventEmitter<any>();
  @Output() farmoutCancel = new EventEmitter<any>();
  @Output() markPaid = new EventEmitter<any>();
  @Output() dropTrip = new EventEmitter<any>();
  @Output() markRead = new EventEmitter<any>();
  @Output() memberVrText = new EventEmitter<any>();
  @Output() confirmationText = new EventEmitter<any>();
  @Output() confirmationCall = new EventEmitter<any>();
  @Output() associateImage = new EventEmitter<any>();
  @Output() partialEdit = new EventEmitter<any>();
  @Output() markMethadone = new EventEmitter<any>();
  @Output() tripLog = new EventEmitter<any>();
  @Output() archive = new EventEmitter<any>();
  @Output() markDeadMiles = new EventEmitter<any>();
  @Output() checkList = new EventEmitter<any>();
  @Output() routeTracker = new EventEmitter<any>();
  @Output() dialysis = new EventEmitter<any>();
  @Output() createStandingOrder = new EventEmitter<any>();
  @Output() willcallActivation = new EventEmitter<any>();
  @Output() editCancelReason = new EventEmitter<any>();
  @Output() isLastTrip = new EventEmitter<any>();
  @Output() disableAutoFarmout = new EventEmitter<any>();
  @Output() aiAssistantConversation = new EventEmitter<any>();
  @Output() markCancelled = new EventEmitter<any>();
  // @Output() reassignTrip = new EventEmitter<any>();
  // @Output() edit = new EventEmitter<any>();
  // @Output() edit = new EventEmitter<any>();
  isClose = false;
  isClone = false;
  isTripModificationNotAllowed = false;
  isTaxiRide = false;

  constructor() { }

  ngOnInit() {
    const fundingSource = this.assign.cooperate ? this.preCooperates[this.assign.cooperate] : null;
    if (fundingSource) {
      if (fundingSource.companyType && fundingSource.companyType === 'taxi') {
        this.isTaxiRide = true;
      }
      if (fundingSource.isTripModificationNotAllowed) {
        this.isTripModificationNotAllowed = true;
      }
    }
    window.addEventListener("keyup", this.initializeTimer);

  }

  initializeTimer = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "∆" || e.key.toLowerCase() === "√")
    ) {
      this.isClone = !this.isClone;
    }
  };

  ngOnChanges(): void {
  }

  isStringExist(substrings, str) {
    if (substrings.some(v => str.toLowerCase().includes(v))) {
      return true;
    }
    return false;
  }

   isTodayOrFuture(scheduleTime: string): boolean {
    const tripDate = moment.tz(scheduleTime, this.timeZone).startOf('day');
    const today = moment.tz(this.timeZone).startOf('day');

    return tripDate.isSameOrAfter(today);
  }



}
